import { localize } from '@spyglassmc/locales';
export function localizeTag(type) {
    return localize(`nbt.node.${type.replace(/^nbt:/, '')}`);
}
//# sourceMappingURL=util.js.map